module.exports = __webpack_public_path__ + "static/media/2.a5b0c14e.svg";